// src/PrintCode.js
import React, { useEffect } from 'react'
import QRCode from 'react-qr-code'
import { useQuery } from '../../hook/useQuery'

const PrintCode = () => {
  const query = useQuery()

  useEffect(() => {
    setTimeout(() => {
      window.print()
      window.close()
    }, 500)
  }, [])

  return (
    <>
      {/* ✅ GLOBAL PRINT CSS */}
      <style>
{`
  @page {
    size: 3.9in 2.4in !important;
    margin: 0 !important; /* 🔥 penting: hilangkan margin page */
  }

  html, body {
    width: 3.9in !important;
    height: 2.4in !important;

    margin: 0 !important;
    padding: 0 !important;

    overflow: hidden !important; /* 🔥 cegah halaman kedua */
    background: #fff !important;

    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #root {
    width: 100% !important;
    height: 100% !important;
    overflow: hidden !important;
  }

  * {
    box-sizing: border-box !important;
    color: #000 !important;
  }
`}
</style>

      <div style={styles.page}>
        <div style={styles.card}>
          {/* LEFT */}
          <div style={styles.left}>
            <div style={styles.name}>{query.get('name') ?? ''}</div>
            <div style={styles.position}>{query.get('position') ?? ''}</div>
            <div style={styles.company}>{query.get('company') ?? ''}</div>
          </div>

          {/* RIGHT */}
          <div style={styles.right}>
            <QRCode value={query.get('code') ?? ''} size={130} />
            <div style={styles.userId}>
              ID: {query.get('userid') ?? ''}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const styles = {
page: {
  fontFamily: 'Arial, sans-serif',
  background: '#fff',

  width: '100%',
  height: '100%',

  display: 'flex',
  justifyContent: 'flex-start', // ❗ jangan center di sini
  alignItems: 'flex-start',

  color: '#000',
},

card: {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',

  width: '3.9in',
  height: '2.4in',

  padding: '5px',
  boxSizing: 'border-box',

  overflow: 'hidden', // 🔥 penting
},

  left: {
    width: '58%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '4px',
  },

  right: {
    width: '42%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  name: {
    fontSize: '19px',
    fontWeight: '800',
    lineHeight: '1.1',
  },

  position: {
    fontSize: '14px',
    fontWeight: '700',
  },

  company: {
    fontSize: '13px',
  },

  userId: {
    fontSize: '11px',
    marginTop: '4px',
  },
}

export default PrintCode